const CONSTANTS = {
    DEFAULT_PAGE_SIZE: 30,
    IS_LIKE: 1,
    // NO_LIKE: 0,
    IS_LIKE_BACK: 1,
    IS_MATCHING: 1,
    IS_FAVORITE: 1,
    // NO_FAVORITE: 0,
    IS_ONLINE: true,
    NO_ONLINE: false,
    IS_CALL: 1,
    // NOT_CALL: 0,
    MALE: 0,
    FEMALE: 1,
    IS_WAITING_FOR_MEET: 1,
    NOT_WAITING_FOR_MEET: 0,
    URL_DEFAULT: "media3/images/default",
    VIEW_STATUS_AVATAR_ALL: 0,
    VIEW_STATUS_AVATAR_LIKE: 1,
    VIEW_STATUS_AVATAR_MATCHING: 2,
    NOT_VALUE: "未設定",
    DESCRIBED: "記載有",
    NO_DESCRIBED: "記載無",
    IS_SUBSCRIPTION: 1,
    AUTO_COMPLETE_TEMPLATE_MESSAGE: 1,

    // Cookie
    COOKIE_ACCESS_TOKEN: 'access_token',
    COOKIE_TOKEN: 'token',
    COOKIE_SESSION_REMEMBER_ME: 'remember_me',
    COOKIE_SESSION_JOB: 'job',
    COOKIE_SESSION_HEIGHT: 'height',
    COOKIE_SESSION_STYLE: 'style',
    COOKIE_SESSION_INCOME: 'income',
    COOKIE_SESSION_HOLIDAYS: 'holidays',
    COOKIE_SESSION_MTG_CON: 'meeting_condition',
    COOKIE_SESSION_PURPOSE: 'purpose',
    COOKIE_SESSION_MOOD_STATUS: 'mood_status',
    COOKIE_SESSION_PR: 'pr',
    COOKIE_DEVICE_ID: 'device_id',
    // Tạm thời set expire 30 ngày
    COOKIE_EXPIRE_DAY: 30,

    // Login page
    LOGIN_FAIL_ALERT: 'ユーザー名またはパスワードが正しくありません。',
    COMMON_BUTTON_DISABLE: 'background: #bdbdbd',
    COMMON_BUTTON_ENABLE: 'background: -webkit-linear-gradient(left, rgba(188,151,99,1) 0%, rgba(158,128,90,1) 100%);background: 98%, -o-linear-gradient(left, rgba(188,151,99,1) 0%, rgba(158,128,90,1) 100%);background: linear-gradient(to right, rgba(188,151,99,1) 0%, rgba(158,128,90,1) 100%);',

    // Like
    MESSAGE_LOOK_AT_ME: 'みてねを送りました。',
    IS_LOOK_AT_ME: 1,
    SUB_ACTION_POINT: 1,
    ADD_ACTION_POINT: 1,
    MAX_REQUEST_API: 3,

    GOOGLE_API_KEY: 'AIzaSyC510zV8SpImbLa2mhZ1J9BQ1tmCT3C80U',

    DOMAIN_NAME: 'greedgreed.widosoft.com',

    // Sites management
    CONTENT_URL_STG: 'https://greedgreed.widosoft.com/api/',

    CAMPAIGN_URL_STG: 'https://greedgreed.widosoft.com/api/',     // greedgreed.widosoft.com

    // Template
    TEMPLATE_TYPE_MOOD_STATUS: 1,
    TEMPLATE_TYPE_USER_STATUS: 2,
    DEFAULT_VALUE: 99999999,
    // CALLING CONSTANTS
    CALL_TYPE_PREFLIGHT: 'preflight',
    CALL_TYPE_CALL: 'call',
    CALL_TYPE_CALLING: 'calling',
    CALL_TYPE_SIGMABLUR: 'sigmaBlur',
    CALL_TYPE_ACCEPT: 'accept',
    CALL_TYPE_DENIED: 'denied',
    CALL_TYPE_CANCEL: 'cancel',
    CALL_TYPE_DONE: 'done',
    CALL_TYPE_REPORT: 'report',

    CALL_RECIEVE_OFFER: 0,
    CALL_RECIEVE_ANSWER: 1,
    CALL_SENT_OFFER: 2,
    CALL_SENT_ANSWER: 3,
    CALL_SENT_REPORT: 4,
    CALL_RECEIVE_REPORT: 5,

    CHAT_CENTER_VOICE: 'voice_call',
    CHAT_CENTER_VIDEO: 'video_call',

    MSG_RECEIVE_TYPE: {
        GIFT: 'gift',
    },

    SUPPORTS_VIDEO: 1, // Support
    NOT_SUPPORTS_VIDEO: 0, // Not support

    // MESSAGE STATUS
    MSG_STAUS_NOT_RECIEVE: 0,
    MSG_STAUS_RECIEVED: 1,
    MSG_STATUS_READ: 2,

    CALL_STATUS: {
        START: -1,
        PREFLIGHT: -2,
        CALLING: 0,
        ACCEPT: 1,
        DENIED: 2,
        CANCEL: 3,
        DONE: 4,
        BUSY: 5
    },

    IS_WAITING: 1,
    NO_WAITING: 0,
    IS_READ: 1,
    TYPE_NOTICE_BANNER: 'ads_banner',
    TYPE_NOTICE_CONTACT: 'contact',
    PC_APPROVE: 1, // Đang chờ approve
    IS_APPROVE: 0, // Đã approve,
    DEFAULT_AVATAR: 0,
    URL_TEMP_AVATAR: 'temp/larger_avatar',
    NO_POINT: 'no_point',
    FIRST_MESSAGE_STATUS_NONE: 0,
    FIRST_MESSAGE_STATUS_APPROVING: 1,
    FIRST_MESSAGE_STATUS_APPROVED: 2,
    PC_VERY_AGE: 0,
    NO_VERY_AGE: -1,
    IS_VERY_AGE: 1,
    TYPE_VERY_AGE: 1,
    NO_SUBSCRIPTION: null,
    PC_SUBSCRIPTION: 0,
    IS_NEW: 1,
    ENABLED_CALL: 1,
    UNBLOCK: 0,
    BLOCK: 1,
    HIDDEN_MESSAGE: 1,
    UN_HIDDEN_MESSAGE: 0,
    IS_BONUS: 1,
    STEP_REGISTER_INFO: 1,
    STEP_REGISTER_UPDATE_INFO: 2,
    STEP_REGISTER_DONE: 3,
    IS_VERIFY_PHONE_NUMBER: 1,
    VERIFY_PHONE_NUMBER_SUCCESS: 1,
    UN_FAVORITES_STATUS: 0,
    FAVORITES_STATUS: 1,
    LOCK_STATUS: 1,
    UN_LOCK_STATUS: 0,
    TYPE_VERIFY_INCOME: 3,
    TYPE_VERIFY_ASSET: 2,
    IS_PIN_CHAT: 1,
    NO_READ_MESSAGE: 2,
    IS_READ_MESSAGE: 0,
    NO_DATA: 999,
    SEND_MESSAGE_GIFT: "ギフトを送信しました。",
    RECEIVE_MESSAGE_GIFT: "ギフトを受け取りました。",
    SEND_MESSAGE_LOCATION: "現在地を送信しました。",
    RECEIVE_MESSAGE_LOCATION: "現在地を受信しました。",
    SEND_MESSAGE_IMAGE: "画像を送信しました。",
    RECEIVE_MESSAGE_IMAGE: "画像を受信しました。",

    // PUSH APP (p-ber)
    // PUSH_SYS_URL: 'https://pushsystem.widocom.com/public/',
    // PUSH_APP_CODE: 'FPM4GgzZdL',
    // PUSH_APP_KEY: 'sgRcxJPGAaERVrYs3SIqs0tR6AXrh3',

    PUSH_SYS_URL: 'https://111/public/',
    PUSH_APP_CODE: '1111',
    PUSH_APP_KEY: '11111',
}

export default CONSTANTS